import { Button } from '@mui/material';
import { styles } from './Questionnaire.styles';

type SelectButtonProps = {
  selected: boolean;
  onClick?: () => void;
  children: React.ReactNode;
};

export const SelectButton = ({
  selected,
  onClick,
  children,
}: SelectButtonProps) => {
  return (
    <Button
      variant='outlined'
      style={{ ...styles.button, ...(!!selected && styles.buttonSelected) }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
